import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const RuleModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Lunch Gathering Invitation 🍽️</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div className="mb-3">
                    <p><strong>⏰ Time: </strong>12:00 - 13:30 (around 1.5 hours, flexible)</p>
                    <p><strong>📍 Location: </strong>Neihu District, Taipei</p>
                    <p><strong>🙋 Looking for Participants: </strong>1 person</p>
                    <p><strong>🎥 Interaction Mode: </strong>5-minute video call + in-person meetup</p>
                    <p><strong>📩 Contact me via LINE/Instagram/etc： </strong>yourID</p>
                    <p><strong>🍽️ Details: </strong></p>
                    <p>
                        Looking for a local companion to enjoy lunch together while chatting about Taiwan's unique food culture! 
                        Recommend restaurants, share food culture insights, or simply talk about your life.
                    </p>
                </div>
                <hr />
                <div>
                    <p><strong>✅ Add-on Options (NT.200, pay on-site) 🎁</strong></p>
                    <ul>
                    <li>🔓 私藏美食清單 🍜</li>
                    <li>🔓 私藏景點推薦 🏞️</li>
                </ul>
                </div>
                <hr />
                <p>About me :</p>
                <hr />
                <p>💬 If you're interested, send me a message! 😊</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          關閉
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RuleModal;